<dsr-alert
  type="{{alert.type}}"
  title="{{alert.title}}"
  description="{{alert.description}}"
  [visible]="alert.visible">
</dsr-alert>

<rede-login-page
    [attr.loading]="loading || null"
    loginLabel="e-mail"
    loginPlaceholder="usuario@email.com"
    [attr.loginMessageError]="loginMessage"
    passwordLabel="senha"
    [attr.passwordMessageError]="passwordMessage"
    newUserLinkLabel="ainda não tenho cadastro"
    newUserLinkHref="https://www.userede.com.br/usuario/criacao-usuario/email-usuario"
    forgotLinkLabel="esqueci meu acesso"
    forgotLinkHref="https://www.userede.com.br/usuario/reset-senha/email-usuario"
    brandLinkHref="https://www.userede.com.br"
    (submit)="handleSubmit($event)"
>
</rede-login-page>
